export const header = ()=> {
	const headerBurger = document.querySelector('.header__bottom-burger')
	const headerMenu = document.querySelector('.header__menu')

	headerBurger?.addEventListener('click',()=> {
		headerMenu?.classList.toggle('active')
	})
}
